import {Table, Text} from '@mantine/core'

import type {GiftTableRow} from 'src/api/admin/models/organization'
import {formatCurrency} from 'src/lib/format'

type GiftTableDisplayProps = {
    rows: GiftTableRow[]
}

export default function GiftTableDisplay({rows}: GiftTableDisplayProps) {
    if (rows.length === 0) {
        return (
            <Text size="sm" c="dimmed">
                Set a campaign goal to generate the gift table. Topline defaults to 20% and can be
                changed above.
            </Text>
        )
    }

    return (
        <Table>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th>Gift Size</Table.Th>
                    <Table.Th>Number Required</Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
                {rows.map((row) => (
                    <Table.Tr key={row.sortOrder}>
                        <Table.Td>{formatCurrency(row.giftSize)}</Table.Td>
                        <Table.Td>
                            {row.numberRequired === null ? 'Many' : row.numberRequired}
                        </Table.Td>
                    </Table.Tr>
                ))}
            </Table.Tbody>
        </Table>
    )
}
